module.exports = __webpack_public_path__ + "static/media/receta-07.532a3659.png";